import { render, staticRenderFns } from "./LetterInfo.vue?vue&type=template&id=21572450&scoped=true&"
import script from "./LetterInfo.vue?vue&type=script&lang=js&"
export * from "./LetterInfo.vue?vue&type=script&lang=js&"
import style0 from "./LetterInfo.vue?vue&type=style&index=0&id=21572450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21572450",
  null
  
)

export default component.exports